import classnames from 'classnames';
import { Fragment } from 'react';
import { useAppLocale } from 'src/app/hooks/use-locale';
import { PaymentGateway } from 'src/data/services/payments';
import $ from './PayIcons.module.scss';

interface Props {
    gateways: PaymentGateway[];
    fullWidth?: boolean;
    iconVariant?: 'normal' | 'large';
}

export default function PayIcons({ gateways, fullWidth = false, iconVariant = 'normal' }: Props) {
    const appLocale = useAppLocale();

    const extraTextForEnLocale =
        appLocale === 'en' ? <p>Or choose from other trusted local payment methods.</p> : null;

    return (
        // <div className={$.mainWrap}>
        <div
            className={classnames(
                $.wrap,
                fullWidth && $.wrapFullWidth,
                iconVariant === 'large' && $.wrapIconLarge
            )}
        >
            {gateways.map((gateway, i) => (
                <Fragment key={`${gateway.name}-${i}`}>{gateway.icon}</Fragment>
            ))}
            {extraTextForEnLocale}
        </div>
        // </div>
    );
}
